import type { WebContainerProps } from "./types";

export const useStyles = ({
  background,
  colors,
  gradient,
  angle,
}: Pick<WebContainerProps, "background" | "colors" | "gradient" | "angle">) => {
  let bg: React.CSSProperties["background"] = background ?? "transparent";

  if (colors?.length) {
    const stops = gradient?.locations
      ? colors.map((c, i) => {
          const stop = gradient.locations?.[i];
          return stop != null ? `${c} ${stop * 100}%` : c;
        })
      : colors;

    bg = `linear-gradient(${angle ?? 180}deg, ${stops.join(", ")})`;
  }

  return {
    backgroundStyle: {
      background: bg,
    } as React.CSSProperties,

    layoutStyle: {
      display: "flex",
      flexDirection: "column",
      width: "100%",
      height: "100vh",
      overflowY: "auto",
    } as React.CSSProperties,
  };
};
